import * as React from "react"
import {Badge, Box, Typography} from "@mui/material";


export default function BannersPercentageHighLevelLegend({ data }) {
    return <Box display="flex" flexWrap="wrap" p={1.5} gap={2}>
		{ data.map((item, idx) => <Box key={idx} display="flex" alignItems="center" width={100}>
			<Box width={14}>
				<Badge badgeContent=" " sx={{ span: { backgroundColor: item.color || '#6f6f6f' }}} />
			</Box>
			<Typography
                noWrap
                variant="body2"
				overflow="hidden"
				textOverflow="ellipsis"
				mt={0.25}
                ml={0.5}
			>
				{item.label}
			</Typography>
		</Box>) }
    </Box>
}